import ReCAPTCHA from "react-google-recaptcha";
import { getLocaleFromPath, DEFAULT_LOCALE } from "../../../config/locales";

const Captcha = ({ onVerify }) => {
  const handleCaptchaChange = (token) => {
    if (onVerify) {
      onVerify(token); // Pass the token back to the parent component
    }
  };

  const handleCaptchaExpired = () => {
    if (onVerify) {
      onVerify(null); // Notify parent component that the token has expired
    }
  };

  const RECAPTCHA_SITE_KEY = "6LckGIQqAAAAAFc3O-VjJkiQxCXffAZBEy6W5i_r";

  // reCAPTCHA accepts full BCP 47 codes — pass the route locale so
  // en-GB gets British English UI, en gets standard English, etc.
  const captchaLocale = getLocaleFromPath(window.location.pathname) ?? DEFAULT_LOCALE;

  return (
    <ReCAPTCHA
      sitekey={RECAPTCHA_SITE_KEY}
      onChange={handleCaptchaChange}
      onExpired={handleCaptchaExpired}
      hl={captchaLocale}
    />
  );
};

export default Captcha;
